module.exports = __webpack_public_path__ + "static/media/white-sands-usa.645621fa.jpg";